import { Link, useLocation } from 'react-router-dom';

export default function AdminNav() {
  const { pathname } = useLocation();
  const link = (to: string, label: string) => (
    <Link
      key={to}
      to={to}
      className={`admin-nav-link${pathname.startsWith(to) ? ' active' : ''}`}
    >
      {label}
    </Link>
  );
  return (
    <nav className="admin-nav row">
      {link('/admin/orders', '订单')}
      {link('/admin/users', '用户')}
      {link('/admin/config', '配置')}
      <Link to="/" className="admin-nav-link muted">
        前台
      </Link>
    </nav>
  );
}
